import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  private readonly legacyStorageKey = 'authToken';
  private readonly storageKey = 'sipub:authToken';
  private token: string | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.token = this.readStoredToken();
  }

  setToken(token: string): void {
    this.token = token.trim() || null;

    if (!this.token) {
      this.removeStoredToken();
      return;
    }

    this.writeStoredToken(this.token);
  }

  getToken(): string | null {
    if (!this.token) {
      this.token = this.readStoredToken();
    }

    return this.token;
  }

  clear(): void {
    this.token = null;
    this.removeStoredToken();
  }

  private get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  private readStoredToken(): string | null {
    if (!this.isBrowser) return null;

    try {
      const token = window.localStorage.getItem(this.storageKey)?.trim() || null;
      if (token) return token;

      const legacyToken = window.localStorage.getItem(this.legacyStorageKey)?.trim() || null;
      if (legacyToken) {
        this.writeStoredToken(legacyToken);
      }

      return legacyToken;
    } catch {
      return null;
    }
  }

  private writeStoredToken(token: string): void {
    if (!this.isBrowser) return;

    try {
      window.localStorage.setItem(this.storageKey, token);
    } catch {
      this.token = null;
    }
  }

  private removeStoredToken(): void {
    if (!this.isBrowser) return;

    try {
      window.localStorage.removeItem(this.storageKey);
    } catch {}
  }
}
